import { EntityId } from '@reduxjs/toolkit';
import { serveurTypeEntityAdapter } from './serveur-type.slice';
import { RootState } from '../../../_config/redux';

const serveurSelector = serveurTypeEntityAdapter.getSelectors<RootState>((state) => state.serveurType);

export const selectserveurTypeById = (id: EntityId) => (state: RootState) => serveurSelector.selectById(state, id);

export const selectAllserveurTypes = (state: RootState) => serveurSelector.selectAll(state);